/**
 * 房间号持久化（PRD §B.3）
 * key: `pigwords.lastRoom` → `{ roomCode, savedAt }`
 *
 * 注意：token/nickname 走 identity.ts，这里只管 roomCode。
 */

const ROOM_KEY = 'pigwords.lastRoom';

interface StoredRoom {
  roomCode: string;
  savedAt: number;
}

export function saveLastRoom(roomCode: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    const v: StoredRoom = { roomCode, savedAt: Date.now() };
    localStorage.setItem(ROOM_KEY, JSON.stringify(v));
  } catch {
    // ignore
  }
}

export function getLastRoom(): string | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(ROOM_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as Partial<StoredRoom>;
    if (typeof v.roomCode === 'string' && /^\d{4}$/.test(v.roomCode)) {
      return v.roomCode;
    }
    return null;
  } catch {
    return null;
  }
}

export function clearLastRoom(): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(ROOM_KEY);
  } catch {
    // ignore
  }
}
